import { addClickRecord } from "../../../../../Utils/helper";

export const InsuranceButtons = Object.freeze([
  {
    iconClassName: "ic ic-15 ic-generate-document",
    buttonText: "Letter",
    className: "p-l-6 p-r-5",
    style: { height: "25px" },
    onClick: () => {
      addClickRecord(999, 2);
      // TODO: Implement generate document functionality
    },
  },
]);

export const LienButtonsConfig = Object.freeze([
  {
    iconClassName: "ic ic-15 ic-generate-document",
    buttonText: "Letter",
    className: "p-l-6 p-r-5",
    style: {
      height: "25px",
      backgroundColor: "var(--primary-10)",
      borderColor: "var(--primary)",
      color: "var(--primary)",
    },
    onClick: () => {
      addClickRecord(999, 2);
      // TODO: Implement generate document functionality
    },
  },
]);

export const PANEL_TYPES = {
  COMPANY: "company",
  ADJUSTER: "adjuster",
  SUPERVISOR: "supervisor",
  CLAIM: "claim",
  LIEN_ADJUSTER: "lien_adjuster",
  LIEN: "lien",
};
